export default {
    cancel: 'cancel',
    cannotHaveSharp: 'This field must be not included "#" character',
    companySetting: 'Company setting',
    congratulations: 'Congratulations',
    createUserByAdmin: 'Create New User',
    editUserByAdmin: 'Edit User',
    employeeId: 'Employee ID',
    email: 'Email',
    emailIsExceededCharacters: 'E-mail is exceeded 255 characters',
    emailIsRequired: 'E-mail is required',
    incorrectPhoneNumber: 'Incorrect phone number',
    invalidEmailFormat: 'Invalid e-mail format',
    prefixThai: 'Thai Prefix',
    prefixEnglish: 'English Prefix',
    firstNameThai: 'Thai First name',
    firstNameEnglish: 'English First name',
    lastNameThai: 'Thai Last name',
    lastNameEnglish: 'English Last name',
    password: 'Password',
    permissionType: 'Permission Type',
    profile: 'Profile',
    phoneNumber: 'Phone Number',
    save: 'save',
    somethingWrong: 'Something went wrong',
    update: 'Update',
    username: 'Username',
    view: 'View',
    thisFieldIsRequired: 'This field is required',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters'
}
